import Store from '../store';
import locale from '../locale/locale';
import { modelHTML } from './constant';
import { getSheetIndex, getRowName, getColName } from '../methods/get';
import { setluckysheet_scroll_status } from '../methods/set';
import sheetmanage from './sheetmanage';
import luckysheetsizeauto from './resize';
import dataVerificationCtrl from './dataVerificationCtrl';
import { replaceHtml,transformRangeToAbsolute,openSelfModel } from '../utils/util';
import { selectionCopyShow } from './select';
import tooltip from '../global/tooltip';
import cleargridelement from '../global/cleargridelement';

let isInitialPagePrintAddRang = false;

export function openPagePrintModel(){
  initialPagePrintRangeModal()
}
//protect range config  页面打印配置框
function initialPagePrintRangeModal(file){
  // if(isInitialPagePrintAddRang){
  //     return;
  // }
  let dataSource = 2
  isInitialPagePrintAddRang = true;
  let _locale = locale();
  let local_pagePrint = _locale.pagePrint;
  const locale_button = _locale.button;
  // console.log('试试', $('#luckysheet-print-rangeItem-confirm').length)
  if($('#luckysheet-print-rangeItem-dialog').length <= 0){
      $("body").append(replaceHtml(modelHTML, { 
        "id": "luckysheet-print-rangeItem-dialog", 
        "addclass": "luckysheet-print-rangeItem-dialog", 
        "title": local_pagePrint.title, 
        
        "content": `
            <div class="luckysheet-print-rangeItem-content" data-source="${dataSource}">
                <div class="luckysheet-slider-print-row">
                    <div class="luckysheet-slider-print-column luckysheet-print-column-3x">
                        ${local_pagePrint.selectCellRangeRowLabel}
                    </div>
                    <div class="luckysheet-slider-print-column luckysheet-print-column-7x" style="left:30%">
                        <div id="print-allowRangeAdd-row-range" class="range">
                            <input class="formulaInputFocus" readonly="true" spellc heck="false" style="height: 28px" placeHolder="${local_pagePrint.selectCellRangeRowHolder}">
                            <i class="fa fa-table fa-table-row" aria-hidden="true" title="${local_pagePrint.selectCellRangeRowHolder}"></i>
                        </div>
                    </div>
                </div>
                <div class="luckysheet-slider-print-row">
                    <div class="luckysheet-slider-print-column luckysheet-print-column-3x">
                        ${local_pagePrint.selectCellRangeColumnLabel}
                    </div>
                    <div class="luckysheet-slider-print-column luckysheet-print-column-7x" style="left:30%">
                        <div id="print-allowRangeAdd-column-range" class="range">
                            <input class="formulaInputFocus" readonly="true" spellc heck="false" style="height: 28px" placeHolder="${local_pagePrint.selectCellRangeColumnHolder}">
                            <i class="fa  fa-table fa-table-column" aria-hidden="true" title="${local_pagePrint.selectCellRangeColumnHolder}"></i>
                        </div>
                    </div>
                </div>
            </div>
        `, 
        "botton":  `<button id="luckysheet-print-rangeItem-confirm" class="btn btn-primary">${locale_button.confirm}</button>
                    <button id="luckysheet-print-rangeItem-close" class="btn btn-default luckysheet-model-close-btn">${locale_button.cancel}</button>`, 
        "style": "z-index:100003" 
    }));
  }else{
    $('#luckysheet-print-rangeItem-confirm').show()
  }
  

  let printData = luckysheet.getPagePrintData() || {}
  let txtRow = ''
  if(printData.rowRange){
    txtRow = printData.rowRange
  }
  $("#print-allowRangeAdd-row-range input").val(getRowName(txtRow))
  $('#print-allowRangeAdd-column-range input').attr('rangeArea', txtRow)
  let txtCol = ''
  if(printData.rowRange){
    txtCol = printData.columnRange
  }
  $("#print-allowRangeAdd-column-range input").val(getColName(txtCol))
  $("#print-allowRangeAdd-column-range input").attr('rangeArea', txtCol)
  initC()
}
function initC(){
  $('#print-allowRangeAdd-row-range .fa-table-row').on('click', function(){
    dataSource = "2";
    // let txt = $(this).siblings("input").val().trim(); 
    // dataVerificationCtrl.rangeDialog(dataSource, txt);
    $('#luckysheet-print-rangeItem-dialog .luckysheet-print-rangeItem-content').attr("data-source", dataSource)
  })
  $('#print-allowRangeAdd-column-range .fa-table-column').on('click', function(){
    dataSource = "3";
    // let txt = $(this).siblings("input").val().trim();
    // dataVerificationCtrl.rangeDialog(dataSource, txt);

    $('#luckysheet-print-rangeItem-dialog .luckysheet-print-rangeItem-content').attr("data-source", dataSource)
  })
  $('#luckysheet-print-rangeItem-confirm').on('click', function(){
    let printData = luckysheet.getPagePrintData() || {}
    // let rowVal = $("#print-allowRangeAdd-row-range input").val()
    // let columnVal = $("#print-allowRangeAdd-column-range input").val()
    let rowVal = $("#print-allowRangeAdd-row-range input").attr('rangeArea')
    let columnVal = $("#print-allowRangeAdd-column-range input").attr('rangeArea')
    let rowD = rowVal ? luckysheet.getRangeByTxt(rowVal) : ''
    let columnD = columnVal ? luckysheet.getRangeByTxt(columnVal) : ''
    if(rowD){
      printData.row = `${rowD.row[0]}:${rowD.row[1]}`
      printData.rowRange = rowVal
    }
    if(columnD){
      printData.column = `${columnD.column[0]}:${columnD.column[1]}`
      printData.columnRange = columnVal
    }
    if(printData && (!printData.row && !printData.column)) {
      tooltip.info('提示', '请选择选区');
      return
    }
    luckysheet.setPagePrintConfig(printData)
    // $("#luckysheet-print-rangeItem-dialog").hide();
    $("#luckysheet-print-rangeItem-dialog").remove();
    $("#luckysheet-modal-dialog-mask").hide();
    let range = [];
    selectionCopyShow(range);
  })
  $('#luckysheet-print-rangeItem-close').on('click', function(){
    $("#luckysheet-print-rangeItem-dialog").remove();
    let range = [];
    selectionCopyShow(range);
  })
}